import { pushEventInfo } from '../analytics';

const MY_ACCT_SETTINGS = 'my account settings';

/**
 * Builds the fulfillment breakdown reported alongside a button submission.
 *
 * Shared because the pickup and delivery confirm flows report the same
 * dimension from the two branches of a single click; keeping one
 * implementation is what stops those branches drifting apart.
 */
export const buildFulfillmentTypeSettings = (
  fulfillmentType?: string,
): string => {
  const map: Record<string, string> = {
    ShipToHome: 'sth',
    BuyOnlineShipToStore: 'boss',
    BuyOnlinePickupInStore: 'bopis',
    BuyOnlineDeliverFromStore: 'bodfs',
    Appliance: 'appl',
    DFS: 'unknown',
    DirectDelivery: 'unknown',
    WillCallFulfillment: 'unknown',
    MISC: 'unknown',
    CanceledItems: 'unknown',
    Additional: 'unknown',
    InStorePurchase: 'unknown',
    Returned: 'unknown',
  };

  const active = map[fulfillmentType ?? ''] ?? 'unknown';
  const keys = ['sth', 'boss', 'bopis', 'bodfs', 'appl', 'unknown'];

  return (
    'orders:' +
    keys.map((key) => `${key}:${key === active ? 'y' : 'n'}`).join('|')
  );
};

/** `Purchase History` / `Order Details` - Assign to Project Button Clicked */
export const pushAssignToProjectButtonEvent = (table: boolean) =>
  pushEventInfo({
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: MY_ACCT_SETTINGS },
    myAccount: {
      settings: `${
        table ? 'purchase history' : 'order details'
      }: assign to project`,
    },
  });

export const pushAssignToProjectApplyButtonEvent = (
  isNewProjectAssignment: boolean,
) => {
  pushEventInfo({
    category: { primaryCategory: 'button submission' },
    eventInfo: { eventName: MY_ACCT_SETTINGS },
    myAccount: {
      settings: `assign a project: project new: ${
        isNewProjectAssignment ? 'y' : 'n'
      }: apply`,
    },
  });
};
